import { render, staticRenderFns } from "./VonexDate.vue?vue&type=template&id=4d91f957&scoped=true&"
import script from "./VonexDate.vue?vue&type=script&lang=js&"
export * from "./VonexDate.vue?vue&type=script&lang=js&"
import style0 from "./VonexDate.vue?vue&type=style&index=0&id=4d91f957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91f957",
  null
  
)

export default component.exports